export default __webpack_public_path__ + "img/Poppins-Regular_7d50cfc.woff";